<template>
  <div class="exclusive-content" v-if="exclusives">
    <div class="container-fluid">
      <h4 class="px-3">{{ exclusives.title }}</h4>
      <swiper
        :modules="modules"
        :slides-per-view="slidesPerView"
        :space-between="10"
        :centeredSlides="false"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        navigation
      >
        <swiper-slide v-for="(asset, i) in exclusives.assets" v-bind:key="i">
          <horizontal-card-clean :asset="asset" v-if="isMobile()" />
          <horizontal-card :asset="asset" v-else />
        </swiper-slide>
      </swiper>

      <v-divider v-if="isMobile()"></v-divider>
    </div>
  </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import HorizontalCard from "./carousel/HorizontalCard.vue";
import HorizontalCardClean from "@/components/landing/carousel/HorizontalCardClean.vue";

export default {
  name: "exclusiveContent",
  components: {
    HorizontalCardClean,
    HorizontalCard,
    Swiper,
    SwiperSlide,
  },
  props: {
    exclusives: {
      type: Object,
      default: null,
    },
  },
  data: ()=>{
    return {
      currentWidth: window.innerWidth
    }
  },
  computed: {
    slidesPerView() {
      return this.$breakpoints("home_exclusive", this.currentWidth);
    },
  },
  methods: {
    updateSize() {
      this.currentWidth = window.innerWidth;
    },
  },
  mounted(){
    this.updateSize();
    window.addEventListener("resize", this.updateSize);
  },
  beforeUnmount(){
    window.removeEventListener("resize", this.updateSize);
  },
  setup() {
    const onSwiper = (swiper) => {
      // console.log(swiper);
    };
    const onSlideChange = () => {
      // console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
};
</script>

<style lang="scss">
.exclusive-content {
  background: url("@/assets/img/divider-line.png") no-repeat;
  background-size: contain;
  background-position-x: center;
  background-position-y: 75%;
  --swiper-navigation-top-offset: 45%;
  --swiper-navigation-size: 2em;
  --swiper-navigation-sides-offset: 1em;

  .swiper-button-next,
  .swiper-button-prev {
    top: 42%;
    transform: translateY(-50%);
  }
  h4{
    font-size: 1.7em;
  }
  @media (min-width: 1920px) {
    font-size: 0.7vw;
  }
}
</style>
